import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {Link} from 'react-router-dom';

import {
    setCableLength
} from '../../modules/order'

import {
    setItems
} from '../../modules/packagingTypes'

import axios from 'axios'
import querystring from 'querystring'

import Error from './../../components/Error';

import $ from 'jquery'

class CableLength extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            timeout: null,
            valid: false,
            value: null,
            errorVisible: false,
            minLength: false,
            maxLength: false,
            connector_type_name: ""
        };
    }

    componentDidMount() {
        ReactDOM.findDOMNode(this).scrollIntoView();
        this.getConnectorTypeName();
    }

    getConnectorTypeName(){
        let connector_type_id = this.props.order.connector_type;
        let connector_type_name = "";

        this.props.connectorTypes.items.map(function(connector) {
            if(connector.value === connector_type_id){
                connector_type_name = connector.name;
            }
        });

        this.setState({
            connector_type_name: connector_type_name
        });
    }

    checkLength(event) {

        var value = event.target.value;

        if(this.props.order.product_type === "dragonfly" && (this.state.connector_type_name.indexOf("Break") !== -1 || this.state.connector_type_name.indexOf("Patch") !== -1) && this.state.connector_type_name.toLowerCase().indexOf("dragonfly") === -1){
            value = value.replace(',','.');
            value = value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

            value = value.match(/^\d+\.?\d{0,1}/);
        }else {
            value = value.replace(/\D/g,'');
        }


        var lengthft = value * 3.2808;

        if(this.props.order.product_type === "dragonfly" && (this.state.connector_type_name.indexOf("Break") !== -1 || this.state.connector_type_name.indexOf("Patch") !== -1) && this.state.connector_type_name.toLowerCase().indexOf("dragonfly") === -1){
            lengthft = lengthft.toFixed(2);
        }else {
            lengthft = Math.round(lengthft);
        }



        $('#cable_length').val(value);
        $('#conversion-ft').text(lengthft);

        clearTimeout(this.state.timeout);

        var onTypeChanged = () => { this.onCableLengthChanged(value); }

        this.setState({timeout: setTimeout(function () {
            onTypeChanged();
        }, 500)});

    }

    onCableLengthChanged(value){

        const _this = this;

        if(value != null && value.length > 0){
            this.setState({value: value});
        }else {
            this.setState({value: null});
        }

        axios.post(_this.props.config.api_path+'api/getPackaging', querystring.stringify({
            product_type: this.props.order.product_type,
            connector_type: this.props.order.connector_type,
            fiber_type: this.props.order.fiber_type,
            cable_type: this.props.order.cable_type,
            cable_length: value
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function (response) {
            if(response.data.types.length > 0 && _this.state.value != null && _this.state.value.length > 0){
                _this.setState({valid: true, errorVisible: false, minLength: response.data.minLength, maxLength: response.data.maxLength});

                _this.props.setCableLength({
                    cable_length: _this.state.value
                });

                _this.props.setItems({
                    items: response.data.types
                });

            }else {
                _this.setState({valid: false, errorVisible: true, minLength: response.data.minLength, maxLength: response.data.maxLength});

                _this.props.setCableLength({
                    cable_length: null
                });
            }

        })
        .catch(function (error) {
            console.log(error);
        });
    }

    render()
    {
        return(
            <div className="content-container">
                <div className="content">
                    <div className="configurator_form">
                        <div className="row">
                            <h2>2.4 Cable Length</h2>
                            <p>Select the length of the cable.</p>
                            {this.state.value !== null && this.state.errorVisible && this.state.value.length > 0 && parseFloat(this.state.value) > 0 &&
                                <Error value={this.state.value} minLength={this.state.minLength} maxLength={this.state.maxLength}/>
                            }

                            {(this.props.order.product_type === "powersplit") && this.state.value !== null && this.state.value.length > 0 && parseFloat(this.state.value) > 50 &&
                                <p className="error flash">
                                    Please contact your local sales person if your cable length exceed 50 meters.<br />
                                    Above 50 meters you have to fulfill VDE and ICE power regulations.
                                </p>
                            }

                            {(this.props.order.product_type === "powersplit25") && this.state.value !== null && this.state.value.length > 0 && parseFloat(this.state.value) > 100 &&
                            <p className="error flash">
                                Please contact your local sales person if your cable length exceed 100 meters.<br />
                                Above 100 meters you have to fulfill VDE and ICE power regulations.
                            </p>
                            }

                            <div className="col-dt-50 col-tbl-full">
                                <div className="neutrik-form-section">
                                    <input type="text" className="length" name="cable_length" id="cable_length" placeholder="(in metres)" onChange={(e) => this.checkLength(e)} defaultValue={this.props.order.cable_length != null ? this.props.order.cable_length : ""}/>
                                    <div className="conversion">m. (<span id="conversion-ft"></span> ft.)</div>
                                </div>
                                <p className="annotation"><b>Note:</b> cable length is defined from "antikink to antikink"</p>

                            </div>
                            <div className="col-dt-50 col-tbl-full">

                            </div>
                        </div>

                        {this.props.order.cable_length !== null &&
                            <div>
                                <div className="hr"></div>
                                <div className="align-right">
                                    <Link to="/PackagingType" className="a_button"><button type="button">Next: Choose your packaging »</button></Link>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    config: state.config,
    connectorTypes: state.connectorTypes,
    order: state.order
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setCableLength,
    setItems
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CableLength)



// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/CableLength/index.js